import { type Maybe, maybe } from '@passionware/monads';
import {
  withWorkspaceScoping,
  type WorkspaceScoping
} from 'v5/api/_common/query/workspace-scoping';
import type {
  ResourceQuery,
  ResourceSearchQuery
} from 'v5/api/resource/resource.api';

/**
 * The search a picker reads in the scope its host names: one workspace's resources
 * (`workspaceScopingQueryUtils.ofWorkspace`) or the organization's (`ofGlobal()`). A scope not
 * known yet reads nothing; it never falls back to the organization.
 */
export function scopedResourceQuery(
  query: Maybe<ResourceSearchQuery>,
  scope: Maybe<WorkspaceScoping>
): Maybe<ResourceQuery> {
  if (maybe.isAbsent(query) || maybe.isAbsent(scope)) return maybe.ofAbsent();
  return withWorkspaceScoping(query, scope);
}
